import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import woman from './images/woman.svg';
// import man from './images/man.svg';

import defaultAvatar from './images/account-circle-material.svg';

// const renderDefault = gender => gender ? man : woman;

const Avatar = ({ user, clickHandl }) => (
  <button className="avatar" onClick={clickHandl}>
    <img
      src={user.img ? user.img : defaultAvatar}
      alt="avatar"
      style={{
        width: '100%'
      }}
    />
  </button>
);

Avatar.defaultProps = {
  clickHandl: () => {}
};

Avatar.propTypes = {
  // eslint-disable-next-line
  user: PropTypes.object.isRequired,
  clickHandl: PropTypes.func
};


const mapStateToProps = state => ({
  user: state.user.user
});


export default connect(mapStateToProps)(Avatar);



// WEBPACK FOOTER //
// ./src/components/Avatar/index.js